import { IconDefinition, faCircleInfo } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Checkbox, FormControl, FormControlLabel, Typography, useMediaQuery } from "@mui/material";
import parse from 'html-react-parser';
import LightTooltip from "../../../components/LightTooltip";
import ListaPermissao from "../../../interfaces/entities/Permissoes/ListaPermissao";
import TipoPermissao from "../../../interfaces/entities/Permissoes/TipoPermissao";
import './styles.css';
import { sxFormControlLabel, sxFormTitle, sxTooltipRadioFormLabel } from "./sxProps";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { useId } from "react";

const ViewPermissionForm: React.FC<{
  toggleOption: (newOption: ListaPermissao) => void;
  formData?: TipoPermissao;
  formTitle: string;
}> = ({ toggleOption, formData, formTitle }) => {

  const uniqueId = useId();

  const { textStyleAccessibility, contrastColorAccessibility, contrastMode } = useAccessibility();

  const mobileScreen = useMediaQuery('(max-width: 768px)');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, newOption: ListaPermissao) => {
    if (newOption.idPermissao === '10' && !(event.target.checked)) { //NÃO PERMITE SELECIONAR "BLOQUEAR TOTALMENTE" CASO JÁ ESTEJA SELECIONADO
      return;
    } else {
      toggleOption(newOption);
    }
  }

  return (
    <Box sx={{ width: mobileScreen ? "100%" : "auto" }}>
      <div>
        <Typography style={textStyleAccessibility} sx={sxFormTitle}>{formTitle}</Typography>
      </div>
      
      <label id={`${uniqueId}-label`} htmlFor={uniqueId} aria-label={`${formTitle} ${formData?.listaPermissao.length} itens.`} />
      <FormControl 
        component="fieldset" 
        sx={{ width: '100%' }} 
        role="group" 
        id={uniqueId}
        aria-labelledby={`${uniqueId}-label`}
      >
        {formData?.listaPermissao.map((permissao, index) => (
          <div style={{display: 'flex', alignItems: 'center'}}>
          <FormControlLabel
            sx={sxFormControlLabel}
            key={permissao.idPermissao}
            value={permissao.valor}
            aria-label={`item ${index + 1} de ${formData?.listaPermissao.length}: ${permissao.descr}`}
            control={
              <Checkbox
                onChange={(event) => handleChange(event, permissao)}
                style={contrastColorAccessibility}
                checked={permissao.valor}
              />}
            label={
              <Box 
                style={textStyleAccessibility}
                sx={sxTooltipRadioFormLabel}>
                {permissao.descr}
              </Box>
            }
          />
          <LightTooltip
            title={parse(permissao.txtAjuda)}
            placement="right"
            id={permissao.idPermissao}
          >
            <FontAwesomeIcon icon={faCircleInfo as IconDefinition} className={`${contrastMode ? 'fa-icon18x18-accessibility' : 'fa-icon18x18'}`} />
          </LightTooltip>
          </div>
        ))}
      </FormControl>
    </Box>
  )
}

export default ViewPermissionForm;